/**
 * Parses ad attributes by removing leading/trailing whitespace and joining lines.
 *
 * @param {string} adAttributes - The ad attributes to parse.
 * @returns {string} The parsed ad attributes.
 */
export const parseAdAttributes = (adAttributes) => (
  adAttributes
).replace(/^\s+|\s+$/gm, "").split("\n").join("");
